import React, {useContext, useRef, useEffect} from "react";

import {BackHandler}  from 'react-native';

import contexto from '../util/contexto'

import {useNavigation} from '@react-navigation/native'

import * as util from '../util/util'

import { ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import FormularioSelecionarItem, {TIPO_GESTAO_ITEM} from '../componentes/FormularioSelecionarItem'

import {TELA_MEUS_ITENS, TELA_NOVO_ITEM} from '../util/constantes'



export default function TelaMeusItens(){

	const {setValorContexto} = useContext(contexto);

	const navegacao = new useNavigation();

	const formularioSelecionarItem  = useRef(null)

	
	const voltar = () => {
			
		navegacao.replace(util.processaVoltar())
		
		return true;
	};


	useEffect(() => {
		
		util.print("TelaMeusItens");

		BackHandler.addEventListener('hardwareBackPress', voltar);
		
		return () => {
		  BackHandler.removeEventListener('hardwareBackPress', voltar);
		};

	}, []); 


	const novoItem= async ()=>{

		util.setVoltar(TELA_MEUS_ITENS);

		navegacao.navigate(TELA_NOVO_ITEM)
	}


	const verItem= async (item)=>{

		setValorContexto(prevState =>({...prevState, idItem: item.id}));

		util.setVoltar(TELA_MEUS_ITENS)

		navegacao.navigate('detalheItem')
	}

		
	return (

		<ViewDegradeVertical titulo="Meus Produtos/Serviços" voltar={()=>voltar()}>  
			<FormularioSelecionarItem ref={formularioSelecionarItem} 
											tipo={TIPO_GESTAO_ITEM}
												verItem={verItem}
													novoItem={novoItem}
														voltarPara={TELA_MEUS_ITENS}/>
		</ViewDegradeVertical>
	);

}